<template>
  <div class="create-room">
    <navbarStaff />
    <div class="space"></div>
    <div class="container">
      <div class="add-name-room">
        <!-- ===================================== Modal add room =======================================-->
        <!-- 
            - room_name
            - room_status deflut = 0
            - min_person 
            - max_person
            - usefor_group_id เชื่อมกับ ตาราง usefor
            - barcode 
            - room_description
            - floor
            - room_type เชื่อมกับ ตาราง usefor_group 
        -->

        <b-modal
          id="modal-prevent-closing"
          ref="modal"
          title="Enter room name"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
        >
          <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group
              label="Name"
              label-for="name-input"
              invalid-feedback="Name is required"
              :state="nameState"
            >
              <b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
        </b-modal>
        <!-- ===========================================================================================-->

        <div class="card-columns">
          <div class="mt-5">
            <span class="pull-left bold-700"> Staff / Room</span>
          </div>
          <div class="mb-6">
            <b-button
              pill
              variant="success"
              class="pull-right"
              v-b-modal.modal-prevent-closing
              ><i class="fa-solid fa-circle-plus"></i> Add</b-button
            >
          </div>
          <br />
          <br />

          <div class="card card-order-list calendar-border">
            <div class="card-body">
              <b-table
                striped
                :fields="fields"
                hover
                :items="items"
                responsive="sm"
                class="text-left"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(control)>
                  <div style="display: flex; gap: 16px">
                    <i
                      class="fa-solid fa-pen-to-square"
                      style="color: skyblue"
                    ></i>
                    <i class="fa-solid fa-trash-can" style="color: #f55151"></i>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbarStaff from "../layouts/navbar_staff.vue";
import axios from "axios";
export default {
  components: { navbarStaff },
  data() {
    return {
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      items: [],
      fields: [
        // sortable: true
        { key: "index", label: "ลำดับ" },
        { key: "room_name", label: "ชื่อห้อง" },
        { key: "room_desc", label: "รายละเอียดห้อง" },
        // { key: "floor", label: "ชั้นที่" },
        { key: "status", label: "สถานะ" },
        { key: "control", label: "จัดการ" },
      ],
      name: "",
      nameState: null,
      submittedNames: [],
      code: "",
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },
    };
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("auth"));
    this.code = this.auth.std_code;

    this.getroom();
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // console.log("name===",this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    getroom() {
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };

      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      // this.$isLoading(true);

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);

          if (res.data.msg.status === 200) {
            this.items = res.data.room_status;
            console.log("Get Room", res);
            // this.$isLoading(false);
          } else {
            alert(res.data.msg.message);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.create-room {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.space {
  height: 100px;
}
.card-columns .card {
  border-radius: 20px;
}
.card-columns {
  column-count: 1;
}
.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
</style>
